import createIcon from '../../createIcon';

/**
 * @component @name Cyclone
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgOEM5Ljc5IDggOCA5Ljc5IDggMTJDOCAxNC4yMSA5Ljc5IDE2IDEyIDE2QzE0LjIxIDE2IDE2IDE0LjIxIDE2IDEyQzE2IDkuNzkgMTQuMjEgOCAxMiA4Wk0xMiAxNEMxMC45IDE0IDEwIDEzLjEgMTAgMTJDMTAgMTAuOSAxMC45IDEwIDEyIDEwQzEzLjEgMTAgMTQgMTAuOSAxNCAxMkMxNCAxMy4xIDEzLjEgMTQgMTIgMTRaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjIgNy40N1Y1LjM1QzIwLjA1IDQuNzcgMTYuNTYgNCAxMiA0QzkuODUgNCA3Ljg5IDQuODYgNi40NiA2LjI0QzYuNTkgNS4zOSA2Ljg2IDMuODQgNy40NyAySDUuMzVDNC43NyAzLjk1IDQgNy40NCA0IDEyQzQgMTQuMTUgNC44NiAxNi4xMSA2LjI0IDE3LjU0QzUuMzkgMTcuNCAzLjg0IDE3LjE0IDIgMTYuNTNWMTguNjVDMy45NSAxOS4yMyA3LjQ0IDIwIDEyIDIwQzE0LjE1IDIwIDE2LjExIDE5LjE0IDE3LjU0IDE3Ljc2QzE3LjQgMTguNjEgMTcuMTQgMjAuMTYgMTYuNTMgMjJIMTguNjVDMTkuMjMgMjAuMDUgMjAgMTYuNTYgMjAgMTJDMjAgOS44NSAxOS4xNCA3Ljg5IDE3Ljc2IDYuNDZDMTguNjEgNi41OSAyMC4xNiA2Ljg2IDIyIDcuNDdaTTEyIDE4QzguNjkgMTggNiAxNS4zMSA2IDEyQzYgOC42OSA4LjY5IDYgMTIgNkMxNS4zMSA2IDE4IDguNjkgMTggMTJDMTggMTUuMzEgMTUuMzEgMTggMTIgMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Cyclone = createIcon('Cyclone', [
  [
    'path',
    {
      d: 'M12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14Z',
      key: 's521kp',
    },
  ],
  [
    'path',
    {
      d: 'M22 7.47V5.35C20.05 4.77 16.56 4 12 4C9.85 4 7.89 4.86 6.46 6.24C6.59 5.39 6.86 3.84 7.47 2H5.35C4.77 3.95 4 7.44 4 12C4 14.15 4.86 16.11 6.24 17.54C5.39 17.4 3.84 17.14 2 16.53V18.65C3.95 19.23 7.44 20 12 20C14.15 20 16.11 19.14 17.54 17.76C17.4 18.61 17.14 20.16 16.53 22H18.65C19.23 20.05 20 16.56 20 12C20 9.85 19.14 7.89 17.76 6.46C18.61 6.59 20.16 6.86 22 7.47ZM12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C15.31 6 18 8.69 18 12C18 15.31 15.31 18 12 18Z',
      key: '1dd2hc',
    },
  ],
]);

export default Cyclone;
